module.exports = __webpack_public_path__ + "static/media/step-3.33360f51.svg";